<template>
  <div class="modal open">
    <div class="modal_box">
      <div class="header">
        <h4>ログインが必要です</h4>
        <div class="close modal_close" v-on:click="$emit('cancel')"></div>
      </div>
      <div class="inner">
        <p v-if="!rank_free">
          <span class="red">こちらの研修会は複眼経済塾塾生限定です。</span><br><br>
          複眼経済塾塾生の方は「ログイン」ボタンより複眼経済塾にログインの上参加申し込みを行ってください。
        </p>
        <div class="btn_wrap">
          <p class="bold blue alnC mb10">複眼経済塾の塾生の方はこちら</p>
          <router-link :to="{ name: 'UsersSignIn', query: {redirect: this.$route.fullPath}}" class="submit light">ログイン</router-link>
        </div>
        <div class="btn_wrap" v-if="rank_free">
          <p class="bold alnC mb10">イベント申込にはゲスト<br class="sp">ユーザー登録が必要です</p>
          <router-link :to="{ name: 'UsersNewRegistrationFree', query: {redirect: this.$route.fullPath}}" class="submit light skeleton">ゲストユーザー登録して申し込む</router-link>
        </div>
        <div class="btn_wrap" v-if="false">
          <p class="bold alnC mb10">複眼経済塾への入会を<br class="sp">希望される方はこちら</p>
          <router-link :to="{ name: 'UsersRegistration'}" class="submit green">複眼経済塾に入塾する</router-link>
        </div>
        <div class="btn_wrap" v-if="false">
          <p class="bold alnC mb10">参加を希望しない方は<br class="sp">ウィンドウを閉じてください</p>
          <a href="javascript:void(0);" class="submit gray modal_close" v-on:click="$emit('cancel')">ウィンドウを閉じる</a>
        </div>
      </div>
    </div>
    <div class="ovr"></div>
  </div>
</template>

<script>
export default {
  props: {
    target_id: null,
    rank_free: null
  },
}
</script>

<style scoped>
.modal_box .inner .btn_wrap .submit {
  max-width: 400px !important;
}
</style>
